"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _AccordionSummaryView = _interopRequireDefault(require("../summary/AccordionSummaryView"));
var _FacetSectionStyle = _interopRequireDefault(require("./FacetSectionStyle"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var FacetSectionView = function FacetSectionView(_ref) {
  var children = _ref.children,
    classes = _ref.classes,
    section = _ref.section,
    CustomSection = _ref.CustomSection;
  var expandSection = section.expandSection;
  var _ref2 = (0, _react.useState)(expandSection),
    _ref3 = _slicedToArray(_ref2, 2),
    expand = _ref3[0],
    setExpand = _ref3[1];
  var onExpandSection = function onExpandSection() {
    setExpand(!expand);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Accordion, {
    expanded: expand,
    onChange: onExpandSection,
    classes: {
      root: classes.expansionPanelsideBarItem
    }
  }, CustomSection ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(CustomSection, {
    section: section
  })) : /*#__PURE__*/_react.default.createElement(_AccordionSummaryView.default, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.sectionSummaryText
  }, section && section.sectionName)), /*#__PURE__*/_react.default.createElement(_core.AccordionDetails, {
    classes: {
      root: classes.expansionPanelDetailsRoot
    },
    id: section.sectionName
  }, children)));
};
var _default = (0, _core.withStyles)(_FacetSectionStyle.default)(FacetSectionView);
exports.default = _default;